// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActivacionesBtlRouteImport } from './routes/activaciones-btl'
import { Route as AnfitrionasRouteImport } from './routes/anfitrionas'
import { Route as AprobarCotizacionRouteImport } from './routes/aprobar-cotizacion'
import { Route as BajaColdEmailRouteImport } from './routes/baja-cold-email'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CanastasNavidenasCorporativasRouteImport } from './routes/canastas-navidenas-corporativas'
import { Route as ClienteOperacionRouteImport } from './routes/cliente-operacion'
import { Route as ConfirmarContratoRouteImport } from './routes/confirmar-contrato'
import { Route as ConvocatoriaRouteImport } from './routes/convocatoria'
import { Route as CotizarRouteImport } from './routes/cotizar'
import { Route as EventosCorporativosRouteImport } from './routes/eventos-corporativos'
import { Route as ImpulsadorasPromotorasRouteImport } from './routes/impulsadoras-promotoras'
import { Route as MerchandisingCorporativoRouteImport } from './routes/merchandising-corporativo'
import { Route as MiPerfilRouteImport } from './routes/mi-perfil'
import { Route as NosotrosRouteImport } from './routes/nosotros'
import { Route as PoliticaDePrivacidadRouteImport } from './routes/politica-de-privacidad'
import { Route as PortafolioRouteImport } from './routes/portafolio'
import { Route as PostularRouteImport } from './routes/postular'
import { Route as SamplingDegustacionesRouteImport } from './routes/sampling-degustaciones'
import { Route as ServiciosRouteImport } from './routes/servicios'
import { Route as StandsParaFeriasRouteImport } from './routes/stands-para-ferias'
import { Route as TradeMarketingRouteImport } from './routes/trade-marketing'
import { Route as ValidarOrdenRouteImport } from './routes/validar-orden'
import { Route as VolanteoPublicitarioRouteImport } from './routes/volanteo-publicitario'
import { Route as ActivacionesBtlIndexRouteImport } from './routes/activaciones-btl.index'
import { Route as ActivacionesBtlDistritoRouteImport } from './routes/activaciones-btl.$distrito'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CoberturaLimaRouteImport } from './routes/cobertura.lima'
import { Route as CotizarIndexRouteImport } from './routes/cotizar.index'
import { Route as CotizarGraciasRouteImport } from './routes/cotizar.gracias'
import { Route as ImpulsadorasPromotorasIndexRouteImport } from './routes/impulsadoras-promotoras.index'
import { Route as ImpulsadorasPromotorasDistritoRouteImport } from './routes/impulsadoras-promotoras.$distrito'
import { Route as OperacionIndexRouteImport } from './routes/operacion.index'
import { Route as OperacionAccesoRouteImport } from './routes/operacion.acceso'
import { Route as BlogCategoriaCategoryRouteImport } from './routes/blog.categoria.$category'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ActivacionesBtlRoute = ActivacionesBtlRouteImport.update({
            id: '/activaciones-btl',path: '/activaciones-btl',getParentRoute: () => rootRouteImport
          })
const AnfitrionasRoute = AnfitrionasRouteImport.update({
            id: '/anfitrionas',path: '/anfitrionas',getParentRoute: () => rootRouteImport
          })
const AprobarCotizacionRoute = AprobarCotizacionRouteImport.update({
            id: '/aprobar-cotizacion',path: '/aprobar-cotizacion',getParentRoute: () => rootRouteImport
          })
const BajaColdEmailRoute = BajaColdEmailRouteImport.update({
            id: '/baja-cold-email',path: '/baja-cold-email',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CanastasNavidenasCorporativasRoute = CanastasNavidenasCorporativasRouteImport.update({
            id: '/canastas-navidenas-corporativas',path: '/canastas-navidenas-corporativas',getParentRoute: () => rootRouteImport
          })
const ClienteOperacionRoute = ClienteOperacionRouteImport.update({
            id: '/cliente-operacion',path: '/cliente-operacion',getParentRoute: () => rootRouteImport
          })
const ConfirmarContratoRoute = ConfirmarContratoRouteImport.update({
            id: '/confirmar-contrato',path: '/confirmar-contrato',getParentRoute: () => rootRouteImport
          })
const ConvocatoriaRoute = ConvocatoriaRouteImport.update({
            id: '/convocatoria',path: '/convocatoria',getParentRoute: () => rootRouteImport
          })
const CotizarRoute = CotizarRouteImport.update({
            id: '/cotizar',path: '/cotizar',getParentRoute: () => rootRouteImport
          })
const EventosCorporativosRoute = EventosCorporativosRouteImport.update({
            id: '/eventos-corporativos',path: '/eventos-corporativos',getParentRoute: () => rootRouteImport
          })
const ImpulsadorasPromotorasRoute = ImpulsadorasPromotorasRouteImport.update({
            id: '/impulsadoras-promotoras',path: '/impulsadoras-promotoras',getParentRoute: () => rootRouteImport
          })
const MerchandisingCorporativoRoute = MerchandisingCorporativoRouteImport.update({
            id: '/merchandising-corporativo',path: '/merchandising-corporativo',getParentRoute: () => rootRouteImport
          })
const MiPerfilRoute = MiPerfilRouteImport.update({
            id: '/mi-perfil',path: '/mi-perfil',getParentRoute: () => rootRouteImport
          })
const NosotrosRoute = NosotrosRouteImport.update({
            id: '/nosotros',path: '/nosotros',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadRoute = PoliticaDePrivacidadRouteImport.update({
            id: '/politica-de-privacidad',path: '/politica-de-privacidad',getParentRoute: () => rootRouteImport
          })
const PortafolioRoute = PortafolioRouteImport.update({
            id: '/portafolio',path: '/portafolio',getParentRoute: () => rootRouteImport
          })
const PostularRoute = PostularRouteImport.update({
            id: '/postular',path: '/postular',getParentRoute: () => rootRouteImport
          })
const SamplingDegustacionesRoute = SamplingDegustacionesRouteImport.update({
            id: '/sampling-degustaciones',path: '/sampling-degustaciones',getParentRoute: () => rootRouteImport
          })
const ServiciosRoute = ServiciosRouteImport.update({
            id: '/servicios',path: '/servicios',getParentRoute: () => rootRouteImport
          })
const StandsParaFeriasRoute = StandsParaFeriasRouteImport.update({
            id: '/stands-para-ferias',path: '/stands-para-ferias',getParentRoute: () => rootRouteImport
          })
const TradeMarketingRoute = TradeMarketingRouteImport.update({
            id: '/trade-marketing',path: '/trade-marketing',getParentRoute: () => rootRouteImport
          })
const ValidarOrdenRoute = ValidarOrdenRouteImport.update({
            id: '/validar-orden',path: '/validar-orden',getParentRoute: () => rootRouteImport
          })
const VolanteoPublicitarioRoute = VolanteoPublicitarioRouteImport.update({
            id: '/volanteo-publicitario',path: '/volanteo-publicitario',getParentRoute: () => rootRouteImport
          })
const ActivacionesBtlIndexRoute = ActivacionesBtlIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ActivacionesBtlRoute
          })
const ActivacionesBtlDistritoRoute = ActivacionesBtlDistritoRouteImport.update({
            id: '/$distrito',path: '/$distrito',getParentRoute: () => ActivacionesBtlRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CoberturaLimaRoute = CoberturaLimaRouteImport.update({
            id: '/cobertura/lima',path: '/cobertura/lima',getParentRoute: () => rootRouteImport
          })
const CotizarIndexRoute = CotizarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CotizarRoute
          })
const CotizarGraciasRoute = CotizarGraciasRouteImport.update({
            id: '/gracias',path: '/gracias',getParentRoute: () => CotizarRoute
          })
const ImpulsadorasPromotorasIndexRoute = ImpulsadorasPromotorasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ImpulsadorasPromotorasRoute
          })
const ImpulsadorasPromotorasDistritoRoute = ImpulsadorasPromotorasDistritoRouteImport.update({
            id: '/$distrito',path: '/$distrito',getParentRoute: () => ImpulsadorasPromotorasRoute
          })
const OperacionIndexRoute = OperacionIndexRouteImport.update({
            id: '/operacion/',path: '/operacion/',getParentRoute: () => rootRouteImport
          })
const OperacionAccesoRoute = OperacionAccesoRouteImport.update({
            id: '/operacion/acceso',path: '/operacion/acceso',getParentRoute: () => rootRouteImport
          })
const BlogCategoriaCategoryRoute = BlogCategoriaCategoryRouteImport.update({
            id: '/categoria/$category',path: '/categoria/$category',getParentRoute: () => BlogRoute
          })





const ActivacionesBtlRouteChildren = {
  ActivacionesBtlDistritoRoute: ActivacionesBtlDistritoRoute,ActivacionesBtlIndexRoute: ActivacionesBtlIndexRoute
}

const ActivacionesBtlRouteWithChildren = ActivacionesBtlRoute._addFileChildren(ActivacionesBtlRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute,BlogCategoriaCategoryRoute: BlogCategoriaCategoryRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const CotizarRouteChildren = {
  CotizarGraciasRoute: CotizarGraciasRoute,CotizarIndexRoute: CotizarIndexRoute
}

const CotizarRouteWithChildren = CotizarRoute._addFileChildren(CotizarRouteChildren)




const ImpulsadorasPromotorasRouteChildren = {
  ImpulsadorasPromotorasDistritoRoute: ImpulsadorasPromotorasDistritoRoute,ImpulsadorasPromotorasIndexRoute: ImpulsadorasPromotorasIndexRoute
}

const ImpulsadorasPromotorasRouteWithChildren = ImpulsadorasPromotorasRoute._addFileChildren(ImpulsadorasPromotorasRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ActivacionesBtlRoute: ActivacionesBtlRouteWithChildren,AnfitrionasRoute: AnfitrionasRoute,AprobarCotizacionRoute: AprobarCotizacionRoute,BajaColdEmailRoute: BajaColdEmailRoute,BlogRoute: BlogRouteWithChildren,CanastasNavidenasCorporativasRoute: CanastasNavidenasCorporativasRoute,ClienteOperacionRoute: ClienteOperacionRoute,ConfirmarContratoRoute: ConfirmarContratoRoute,ConvocatoriaRoute: ConvocatoriaRoute,CotizarRoute: CotizarRouteWithChildren,EventosCorporativosRoute: EventosCorporativosRoute,ImpulsadorasPromotorasRoute: ImpulsadorasPromotorasRouteWithChildren,MerchandisingCorporativoRoute: MerchandisingCorporativoRoute,MiPerfilRoute: MiPerfilRoute,NosotrosRoute: NosotrosRoute,PoliticaDePrivacidadRoute: PoliticaDePrivacidadRoute,PortafolioRoute: PortafolioRoute,PostularRoute: PostularRoute,SamplingDegustacionesRoute: SamplingDegustacionesRoute,ServiciosRoute: ServiciosRoute,StandsParaFeriasRoute: StandsParaFeriasRoute,TradeMarketingRoute: TradeMarketingRoute,ValidarOrdenRoute: ValidarOrdenRoute,VolanteoPublicitarioRoute: VolanteoPublicitarioRoute,CoberturaLimaRoute: CoberturaLimaRoute,OperacionAccesoRoute: OperacionAccesoRoute,OperacionIndexRoute: OperacionIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)